var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "ArrowRight",

    getDefaultProps () {
        return {"width":"18px","height":"18px","viewBox":"0 0 18 18","version":"1.1","xmlns":"http://www.w3.org/2000/svg","data-svgreactloader":"[[\"http://www.w3.org/2000/svg\",\"xlink\",\"http://www.w3.org/1999/xlink\"],[\"http://www.w3.org/2000/svg\",\"sketch\",\"http://www.bohemiancoding.com/sketch/ns\"]]"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <title>icon-arrow-right-small</title>
  <desc>Created with Sketch.</desc>
  <defs/>
  <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" data-svgreactloader="[[&quot;http://www.bohemiancoding.com/sketch/ns&quot;,&quot;type&quot;,&quot;MSPage&quot;]]">
    <g id="icon-arrow-right-small" data-svgreactloader="[[&quot;http://www.bohemiancoding.com/sketch/ns&quot;,&quot;type&quot;,&quot;MSArtboardGroup&quot;]]" stroke="currentColor" strokeWidth="2">
      <path d="M7,14 L12,9 L7,4" id="Back-Arrow-Copy-3" data-svgreactloader="[[&quot;http://www.bohemiancoding.com/sketch/ns&quot;,&quot;type&quot;,&quot;MSShapeGroup&quot;]]"/>
    </g>
  </g>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



/** WEBPACK FOOTER **
 ** ./assets/icons/arrow-right.svg
 **/